export enum UserFileActionType {
  SET_USER_FILE = 'SET_USER_FILE',
  UPDATE_USER_FILE = 'UPDATE_USER_FILE',
}
